import React from "react";
import "react-accessible-accordion/dist/fancy-example.css";
import { DateFormatter5, DateFormatter6 } from "../../../../Constants";
import { titleCase } from "../../../../Utility";

const ExcelFileTable = ({ExcelDownloadIndents, setExcelDownloadIndents}) => {
  /**
   * Retrieves the formatted timestamp for a specific status value from the status tracking array.
   * @param {Array} status_track - Array of status tracking objects, each containing status details.
   * @param {string} status_value - The status value to search for within the status tracking array.
   * @returns {string} - Formatted date string if a matching status is found and timestamp is valid; '--' otherwise.
   */
  const getValue = (status_track, status_value) => {
    if (status_track && status_track.length > 0) {
      var updated = false;
      for (var i = status_track.length - 1; i >= 0; i--) {
        if (status_track[i].value === status_value) {
          if (status_track[i].updated_by === "company") {
            updated = true;
            if (
              isNaN(status_track[i].timestamp) ||
              status_track[i].timestamp === "" ||
              status_track[i].timestamp === null ||
              status_track[i].timestamp === undefined
            ) {
              return "--"; // Return '--' if timestamp is invalid
            } else {
              return DateFormatter6(status_track[i].timestamp); // Return formatted timestamp
            }
          }
          if (updated !== true) {
            if (
              isNaN(status_track[i].timestamp) ||
              status_track[i].timestamp === "" ||
              status_track[i].timestamp === null ||
              status_track[i].timestamp === undefined
            ) {
              return "--"; // Return '--' if timestamp is invalid
            } else {
              return DateFormatter6(status_track[i].timestamp); // Return formatted timestamp
            }
          }
        }
      }
    }
  };

  return (
    <table style={{ display: "none" }} id="vehicle_tracking_table">
      <thead style={{ background: "whitesmoke" }}>
        <tr>
          <th>User Name</th>
          <th>Indent Request No</th>
          <th>Indent ID</th>
          <th>Created On</th>
          <th>Origin</th>
          <th>Destination</th>
          <th>Truck type</th>
          <th>Date of placement</th>
          <th>Transporter Name</th>
          <th>Initial Quote</th>
          <th>Final Quote</th>
          <th>Savings</th>
          <th>Vehicle No</th>
          <th>Driver Name</th>
          <th>Driver Mobile No.</th>
          <th>Allocated</th>
          <th>Placed</th>
          <th>Dispatched</th>
          <th>Reached</th>
          <th>Unloaded</th>
          <th>Payment Approved</th>
          <th>Paid</th>
        </tr>
      </thead>
      <tbody>
        {ExcelDownloadIndents && ExcelDownloadIndents.length > 0 ? (
          ExcelDownloadIndents.map((indent, index) => {
            // console.log(indent)
            return (
              <tr key={indent.indent_id_sub}>
                <td>
                  {indent.user_list && indent.user_list.length > 0
                    ? indent.user_list.map((it) => {
                        return titleCase(it.user_email.split("@")[0]);
                      })
                    : null}
                </td>
                <td style={{ border: "none" }}>{indent.display_indent_id}</td>
                <td>{indent.indent_id_sub}</td>
                <td>{indent.created_date}</td>
                <td>{indent.origin.location_name}</td>
                <td>{indent.destination.location_name}</td>
                <td>{indent.truck_types[0].value}</td>
                <td>{indent.placement_date}</td>
                <td>{indent.transporter_name}</td>
                {/* First Quote */}
                <td>
                  {indent.from && indent.from === "adhoc" ? (
                    indent.shortlisted_transporters &&
                    indent.shortlisted_transporters.length > 0 ? (
                      <>
                        {indent.shortlisted_transporters.map((t) => {
                          if (t.transporter_id === indent.transporter_id) {
                            return t.rate_list && t.rate_list.length > 0
                              ? t.rate_list[0].rate
                              : t.rate
                              ? t.rate
                              : "-";
                          }
                        })}
                      </>
                    ) : (
                      "-"
                    )
                  ) : null}
                </td>
                {/* Final Quote */}
                <td>
                  {indent.shortlisted_transporters &&
                  indent.shortlisted_transporters.length > 0
                    ? indent.shortlisted_transporters[0].rate
                    : "-"}
                </td>
                {/* Savings */}
                <td>
                  {indent.from && indent.from === "adhoc" ? (
                    indent.shortlisted_transporters &&
                    indent.shortlisted_transporters.length > 0 ? (
                      <>
                        {indent.shortlisted_transporters.map((t) => {
                          if (t.transporter_id === indent.transporter_id) {
                            return t.rate_list && t.rate_list.length > 0
                              ? t.rate_list[0].rate -
                                  t.rate_list[t.rate_list.length - 1].rate
                              : "-";
                          }
                        })}
                      </>
                    ) : (
                      "-"
                    )
                  ) : null}
                </td>
                <td>{indent.truck_details.vehicle_no}</td>
                <td>{indent.truck_details.driver_name}</td>
                <td>{indent.truck_details.driver_phone_number}</td>
                <td>
                  {indent.status_track && indent.status_track.length > 0
                    ? indent.status_track.map((st) => {
                        return st.value === "yet to be placed"
                          ? DateFormatter6(st.timestamp)
                          : DateFormatter5("");
                      })
                    : null}
                </td>
                <td>{getValue(indent.status_track, "placed")}</td>
                {/* <td>{indent.status_track && indent.status_track.length > 0? 
                                    indent.status_track.map((st) => {
                                        return st.value === 'placed'? DateFormatter(st.timestamp):DateFormatter1('')
                                    })
                                :null}</td> */}
                <td>{getValue(indent.status_track, "dispatched")}</td>
                {/* <td>{indent.status_track && indent.status_track.length > 0? 
                                    indent.status_track.map((st) => {
                                        return st.value === 'dispatched'? DateFormatter(st.timestamp):DateFormatter1('')
                                    })
                                :null}</td> */}
                <td>{getValue(indent.status_track, "reached")}</td>
                {/* <td>{indent.status_track && indent.status_track.length > 0? 
                                    indent.status_track.map((st) => {
                                        return st.value === 'reached'? DateFormatter(st.timestamp):DateFormatter1('')
                                    })
                                :null}</td> */}
                <td>{getValue(indent.status_track, "unloaded")}</td>
                <td>{getValue(indent.status_track, "paymentapproved")}</td>
                <td>{getValue(indent.status_track, "paid")}</td>
                {/* <td>{indent.status_track && indent.status_track.length > 0? 
                                    indent.status_track.map((st) => {
                                        return st.value === 'unloaded'? DateFormatter(st.timestamp):DateFormatter1('')
                                    })
                                :null}</td> */}
              </tr>
            );
          })
        ) : (
          <tr>
            <td>No Results Found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default ExcelFileTable;
